import { ReactNode, createContext, useState, useMemo, useContext } from 'react';
import { ToastMessageContextProps } from '../types';

const ToastMessageContext = createContext<{
  toastMessageOptions: ToastMessageContextProps;
  setToastMessage: React.Dispatch<React.SetStateAction<ToastMessageContextProps>>;
} | null>(null);

const ToastMessageContextProvider = ({ children }: { children: ReactNode }) => {
  const [toastMessageOptions, setToastMessage] = useState<ToastMessageContextProps>({
    message: '',
    visible: false,
    duration: 500,
    type: 'success',
    ui: 'simple',
  });
  const toastMessageValue = useMemo(
    () => ({
      toastMessageOptions,
      setToastMessage,
    }),
    [setToastMessage, toastMessageOptions]
  );
  return <ToastMessageContext.Provider value={toastMessageValue}>{children}</ToastMessageContext.Provider>;
};

const useToastMessageContext = () => {
  const context = useContext(ToastMessageContext);
  if (!context) throw new Error('useToastMessageContext has to be used within <ToastMessageContext.Provider>');
  return useMemo(() => context, [context]);
};
export { ToastMessageContextProvider, useToastMessageContext };
